import React, {useState, useRef, useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import TableTopBar from "../../components/tables/top/TableTopBar";
import Pagination from "../../components/common/Pagination";
import AxcBadge from "../../components/common/AxcBadge";
import PopUp from "../../components/popUp/PopUp";
import UserReg from "../../pages/subPages/UserReg";
import Swal from "sweetalert2";
import {delUserInfo, getUserAUTHListAll} from "../../api/apiClient";
import PasswordCheck from "../../pages/subPages/PasswordCheck";
import Button from "react-bootstrap/Button";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import useAuth from "../../hook/useAuth";
import usePdf from "../../hook/usePdf";

const TableAuth = ({
                     currentPage,
                     setCurrentPage,
                     listPageSize,
                     setListPageSize,
                     total,
                     tableList,
                     updateList,
                     getFullData = null,
                     setIsSearch,
                     searchParam,
                     setSearchParam,
                     setTableList,
                     setTotal
                   }) => {

  /*const [auth, setAuth] = useState('');
  useEffect(() => {
    setAuth(sessionStorage.getItem('CURRENT_AUTH'));
  }, []);*/

  const auth = useAuth();

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "인증_.xls")
  }

  const getAllList = () => {
    setIsExport(true);
    getUserAUTHListAll(
        currentPage, listPageSize,
        searchParam.searchOgdpTy,
        searchParam.searchUserId,
        searchParam.searchUserNm)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '인증.pdf')
      }
      setIsExport(false);
      updateList();
    });
  };

  // get select (check or radio) ////////////////////////////////////
  const [checkItem, setCheckItem] = useState({
    user_id: '',
    target: null,
  });

  const handleCheckItem = (e) => {
    setCheckItem((prevState) => {
      return {...prevState, user_id: e.target.dataset.id, target: e.target};
    });
  };

  // delete ////////////////////////////////////
  const delItem = (id) => {
    // const deleteId = e.target.dataset.id;

    if (auth != 2) {
      Swal.fire('권한이 없습니다.');
    } else {
      /*      setPwPopup({
              isVisible: true,
              user_id: null,
              type: "del"
            });*/

      Swal.fire({
        title: `삭제하시겠습니까?`,
        input: 'text',
        text: `선택한 id(${id}) 항목 삭제사유를 입력해주세요.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        preConfirm: (comment) => {
          return delUserInfo(id, comment)
              .then(res => {
                // console.log(res);
                if (res.data.status === 200) {
                  setIsSearch(true);
                  updateList();
                  // checkItem.target.checked = false;
                  Swal.fire(
                      '삭제되었습니다!',
                      '',
                      'success'
                  );
                }
              })
              .catch(err => {
                Swal.fire(
                    err.response.data.message,
                    '',
                    'error'
                );
              })
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setIsSearch(true);
          updateList();
          Swal.fire(
              '삭제되었습니다!',
              '',
              'success'
          );
        }
      });
    }
  };

  const regItem = () => {
    if (auth != 2) {
      Swal.fire('권한이 없습니다.');
    } else {
      /*setPopup({
        isVisible: true,
        user_id: null,
      });*/
      setPwPopup({
        isVisible: true,
        user_id: null,
        type: "reg"
      });
    }
  };

  /* 팝업을 위한 state */
  const [openPopup, setPopup] = useState({isVisible: false, user_id: 0});

  const closePopup = () => {
    setPopup({isVisible: false, user_id: 0});
    setIsSearch(true);
    updateList();
  };

  const handleOpenPopup = (e = null) => {
    setPopup({
      isVisible: true,
      user_id: e.target.dataset.id,
    });
  };

  const [pwPopup, setPwPopup] = useState({isVisible: false, user_id: 0, type: "reg"});

  const closePwPopup = () => {
    setPwPopup({
      isVisible: false,
      user_id: 0,
      type: "reg"
    });
    setIsSearch(true);
    updateList();
  };

  const handlePwPopup = (e = null, type = "reg") => {
    setPwPopup({
      isVisible: true,
      user_id: e.target.dataset.id,
      type: type
    });
  };

  return (
      <>
        <PopUp
            // propTitle={'사용자 정보'}
            propTitle={openPopup.user_id ? '사용자 정보 수정' : '사용자 정보 등록'}
            propShow={openPopup.isVisible}
            propSize={'lg'}
            setShow={closePopup}
        >
          <UserReg
              propUserId={openPopup.user_id}
              hClose={closePopup}
          />
        </PopUp>
        <PopUp
            propTitle={'비밀번호 확인'}
            propShow={pwPopup.isVisible}
            propSize={'lg'}
            setShow={closePwPopup}
        >
          <PasswordCheck
              propUserId={pwPopup.user_id}
              hClose={closePwPopup}
              propSetPopup={setPopup}
              propHandleOpenPopup={handleOpenPopup}
              propType={pwPopup.type}
              propSetPwPopup={setPwPopup}
              propDelItemFunc={delItem}
          />
        </PopUp>
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: getFullData,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '인증',
                  }),
                }}
                propDelete={{
                  isEnable: false,
                  delFunc: delItem,
                }}
                propReg={{
                  isEnable: auth === "2",
                  regFunc: regItem,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  {/*<th className={"table-checkbox"}></th>*/}
                  <th className={""}>사용자ID</th>
                  <th className={""}>사용자명</th>
                  <th className={""}>이동전화번호</th>
                  <th className={""}>소속구분</th>
                  <th className={""}>소속상세</th>
                  <th className={""}>접속권한</th>
                  <th className={""}>비밀번호유효기간</th>
                  <th className={""}>등록일</th>
                  {!isExport && auth === "2" ? <th className={"col"}></th> : ''}
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return <tr key={idx}>
                          <td>{elem.user_id}</td>
                          <td>{elem.user_nm}</td>
                          <td>{elem.user_telno}</td>
                          <td>{elem.ogdp_ty_nm}</td>
                          <td>{elem.ogdp_ty_detail_nm}</td>
                          <td>
                            <AxcBadge propInput={elem.user_grade_nm}
                                      propSuccessText={'슈퍼관리자'}
                            />
                          </td>
                          <td>{elem.password_dt_str}</td>
                          <td>{elem.crt_dt_str}</td>
                          {
                            !isExport && auth === "2" ?
                                (
                                    <td className={"table-checkbox"}>
                                      <Button type={"button"} variant="primary"
                                              data-id={elem.user_id}
                                              onClick={handlePwPopup}
                                      >
                                        수정
                                      </Button>
                                      <span> </span>
                                      <Button type={"button"} variant="danger"
                                              data-id={elem.user_id}
                                              onClick={() => {
                                                handlePwPopup({target: {dataset: {id: elem.user_id}}}, "del");
                                              }}
                                      >
                                        삭제
                                      </Button>
                                    </td>
                                ) : ''
                          }
                        </tr>;
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
                propSearchParam={searchParam}
                propSetSearchParam={setSearchParam}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableAuth;
